import {
    SelectChangeEvent,
    Grid,
    InputLabel,
    TextField,
    Select,
    MenuItem,
    FormControl,
    FormLabel,
    FormControlLabel,
    Checkbox,
    Radio,
    RadioGroup,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect, { MultiValue } from "react-select";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import {
    handleDropDownThunk,
    ChangeRouteNameThunk,
    SelectCollectorThunk,
    SelectWorkingDateThunk,
    ChangeRouteRemarkThunk,
    changeStartingTimeThunk,
    ChangingEndTimeThunk,
} from "../../redux/route/thunk";
import { InitBinGroupListAction, InitBinListAction } from "../../redux/staticInfo/action";
import { BinInfo } from "../../redux/staticInfo/state";
import { IRootThunkDispatch, IRootState } from "../../redux/store";
import { axiosGet } from "../../util/axios";
import styles from "./editCleaningRoute.module.css";
import { initCleanerListThunk } from "../../redux/staticInfo/thunk";
import {
    changeCleaningDetailRouteThunk,
    handleCleanerChangeThunk,
    handleCleaningRouteNameChangeThunk,
    handleDropDownCleaningRouteThunk,
    handleRouteCleaningRemarksChangeThunk,
    setHolidayThunk,
    setWeekdayFlagsThunk,
} from "../../redux/cleaningRoute/thunk";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 150,
        },
    },
};

function EditCleaningRoute() {
    const dataFetchedRef = useRef(false);
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { binGroupList, cleanerList } = useSelector(
        (state: IRootState) => state.staticInfoState
    );

    const {
        selectedDetailRouteList,
        route_name,
        mon,
        tue,
        wed,
        thu,
        fri,
        sat,
        sun,
        holiday,
        cleaner_id,
        remark
    } = useSelector((state: IRootState) => state.cleaningRouteState);

    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        initFormData();
        return () => {
            controller.abort();
        };
    }, []);

    async function initFormData() {
        dispatch(OpenLoadingBarThunk(true));
        const result = await axiosGet("/api/cleaning/cleaner");
        const binGroupRes = await axiosGet("/api/bin/cms/binGroup");
        dispatch(OpenLoadingBarThunk(false));
        if (result.data.success) {
            dispatch(initCleanerListThunk(result.data.cleanerList));
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得清潔者名單"));
        }
        if (binGroupRes.data?.success && binGroupRes.data?.binGroupList) {
            const raw = binGroupRes.data.binGroupList;
            const list = Array.isArray(raw)
                ? raw.map((g: Record<string, unknown>) => ({
                    label: String(g.group_name_tc ?? g.groupNameTc ?? ""),
                    value: Number(g.bin_group_id ?? g.binGroupId ?? 0),
                }))
                : [];
            dispatch(InitBinGroupListAction(list));
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得桶組名單"));
        }
    }

    function handleSelectedBin(binInfo: MultiValue<BinInfo>) {
        const existingUniqueIds = new Set(
            (selectedDetailRouteList || []).map((item) => item.__uniqueId)
        );
        const updatedList = binInfo.map((bin) => {
            if (bin.__uniqueId) {
                return bin;
            }
            return {
                ...bin,
                __uniqueId: `${bin.value}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
            };
        });
        dispatch(changeCleaningDetailRouteThunk(updatedList));
    }

    function handleDragStart(
        e: React.DragEvent<HTMLDivElement>,
        index: number
    ) {
        e.dataTransfer.setData("text/plain", index.toString());
    }
    function handleDragOver(e: React.DragEvent<HTMLDivElement>) {
        e.preventDefault();
    }
    function handleDrop(e: React.DragEvent<HTMLDivElement>, index: number) {
        const draggedIndex = Number(e.dataTransfer.getData("text/plain"));
        dispatch(
            handleDropDownCleaningRouteThunk(
                draggedIndex,
                selectedDetailRouteList!,
                index
            )
        );
        // dispatch(selectedBinInfosThunk(newSelectedBinInfo))
    }
    function handleRouteNameChange(event: ChangeEvent<HTMLInputElement>) {
        console.log(event.target.value);
        dispatch(handleCleaningRouteNameChangeThunk(event.target.value));
    }

    function handleCleanerChange(event: SelectChangeEvent<string>) {
        if (!event.target.value) {
            return;
        }
        dispatch(handleCleanerChangeThunk(event.target.value));
    }

    const weekdays = [
        { key: "mon" as const, label: "星期一", value: mon },
        { key: "tue" as const, label: "星期二", value: tue },
        { key: "wed" as const, label: "星期三", value: wed },
        { key: "thu" as const, label: "星期四", value: thu },
        { key: "fri" as const, label: "星期五", value: fri },
        { key: "sat" as const, label: "星期六", value: sat },
        { key: "sun" as const, label: "星期日", value: sun },
    ];

    function handleWeekdayToggle(
        key: "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun"
    ) {
        const current = { mon, tue, wed, thu, fri, sat, sun }[key];
        dispatch(setWeekdayFlagsThunk({ [key]: current ? 0 : 1 }));
    }

    function handleHolidayChange(event: ChangeEvent<HTMLInputElement>) {
        dispatch(setHolidayThunk(Number((event.target as HTMLInputElement).value)));
    }

    function handleRouteRemark(event: ChangeEvent<HTMLInputElement>) {
        dispatch(handleRouteCleaningRemarksChangeThunk(event.target.value));
    }

    return (
        <Grid>
            <Grid className={styles.formOuterContainer}>
                <Grid className={styles.routeNameAndEffectiveOuterContainer}>
                    <Grid className={styles.routeNAmeContainer}>
                        <InputLabel htmlFor="date-picker">車線名稱*</InputLabel>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            onChange={handleRouteNameChange}
                            value={route_name}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid>
                    <InputLabel id="district-area-id">收集者*</InputLabel>
                    <div>
                        <Select
                            labelId="district-area-id"
                            required
                            id="district-area-id"
                            label="區域"
                            MenuProps={MenuProps}
                            value={cleaner_id!}
                            onChange={handleCleanerChange}
                            fullWidth
                        >
                            <MenuItem value="">
                                <em>------</em>
                            </MenuItem>
                            {cleanerList?.map((list) => (
                                <MenuItem
                                    value={list.user_id}
                                    key={`role-${list.user_id}`}
                                >
                                    {list.username}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </Grid>

                <Grid>
                    <FormControl>
                        <FormLabel id="weekday-checkbox-group-label">
                            工作日*
                        </FormLabel>
                        <Grid container rowGap={0} columnGap={1} sx={{ pt: 0.5 }}>
                            {weekdays.map(({ key, label, value }) => (
                                <FormControlLabel
                                    key={key}
                                    control={
                                        <Checkbox
                                            checked={value === 1}
                                            onChange={() => handleWeekdayToggle(key)}
                                        />
                                    }
                                    label={label}
                                />
                            ))}
                        </Grid>
                    </FormControl>
                </Grid>

                <Grid>
                    <FormControl required>
                        <FormLabel id="holiday-radio-label">假日是否適用</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="holiday-radio-label"
                            name="holiday-radio"
                            value={holiday === null ? "" : String(holiday)}
                            onChange={handleHolidayChange}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="是" />
                            <FormControlLabel value="0" control={<Radio />} label="否" />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid>
                    <Grid>
                        <InputLabel id="district-area-id">
                            廁所組合*
                        </InputLabel>
                        <ReactSelect
                            options={binGroupList}
                            isSearchable
                            menuPlacement="auto"
                            menuPosition="fixed"
                            isMulti
                            hideSelectedOptions={false}
                            value={selectedDetailRouteList}
                            getOptionValue={(option) => option.__uniqueId || String(option.value)}
                            onChange={(bin) => handleSelectedBin(bin)}
                        />
                    </Grid>
                </Grid>

                <Grid>
                    <Grid>
                        <InputLabel id="district-area-id">
                            車線次序 （可用drag Drop 調校）
                        </InputLabel>
                    </Grid>

                    <Grid className={styles.routeSequenceContainer}>
                        {selectedDetailRouteList?.map((item, index) => (
                            <Grid
                                key={item.__uniqueId || `bin-group-${item.value}-${index}`}
                                className={styles.routeSequenceInnerContainer}
                                draggable
                                onDragStart={(e) => handleDragStart(e, index)}
                                onDragOver={handleDragOver}
                                onDrop={(e) => handleDrop(e, index)}
                            >
                                <Grid
                                    className={
                                        styles.routeIndexAndNameContainer
                                    }
                                >
                                    <Grid>{index + 1}</Grid>
                                    <Grid>{item.label}</Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>

                <Grid>
                    <InputLabel id="district-area-id">備註</InputLabel>
                    <TextField
                        id="outlined-multiline-static"
                        multiline
                        rows={4}
                        placeholder="請輸入備註(若有)"
                        fullWidth
                        value={remark}
                        onChange={handleRouteRemark}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default EditCleaningRoute;
